package de.oevbs.kunde.kundenportal2.model.services.tax

import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse

abstract class TaxClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

    override val requestTimeoutMillis: Long = 30000L

    /**
     * Läd alle Kfz-Verträge der letzten 3 Jahre (heute und 2 Vorjahre) und gibt sie nach Jahreszahl geschlüsselt zurück.
     * Es werden auch die altuell stornierten Verträge geprüft - jeder Vertrag, der im betreffenden Jahr aktiv war,
     * wird zurückgegeben.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun init(): ClientResponse<TaxInit> =
        get("/tax/init")

    /**
     * Fordert für jeden Kfz-Vertrag in [Tax.selectedContracts] des Jahres [Tax.selectedYear] eine Steuerbescheinigung
     * über den Komposit-Azure-Service an (Dunkelverarbeitung) und erstellt einen Kontakt in den Kundendaten.
     *
     * [TaxResult] enthält eine Liste der fehlgeschlagenen und erfolgreichen Anforderungen (Vertragsnummern).
     * Wenn alle Anforderungen fehlschlagen, kommt eine Failure mit Fehlermeldungen zurück.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun create(tax: Tax): ClientResponse<TaxResult> =
        post("/tax/create", tax)
}